































































































import { Component, Prop, Vue } from 'vue-property-decorator';
import FormRow from '@/components/common/forms/FormRow.vue';
import FormInput from '@/components/common/forms/FormInput.vue';
import FormError from '@/components/common/forms/FormError.vue';
import { AnnouncementModel } from 'admiral-core';
import FormTextarea from '@/components/common/forms/FormTextarea.vue';
import MdComponent from '@/components/common/MdComponent.vue';
import AdmiralCheckbox from '@/components/common/selects/AdmiralCheckbox.vue';
import { CheckIcon } from 'vue-feather-icons';
import Multiselect from 'vue-multiselect';

@Component({
  components: {
    MdComponent,
    FormTextarea,
    FormError,
    FormInput,
    FormRow,
    AdmiralCheckbox,
    CheckIcon,
    Multiselect,
  },
})
export default class AnnouncementForm extends Vue {
  @Prop({ required: true, type: Object })
  readonly value!: AnnouncementModel;

  @Prop({ required: true, type: Object })
  readonly errors!: AnnouncementModel;

  async mounted() {
    //
  }

  get content() {
    return this.value.content + '';
  }

  onInput(key: string, value: any) {
    // if (key === 'content') {
    //   this.content = value;
    // }

    this.$emit('input', { ...this.value, [key]: value });
  }
}
